import React from "react";

import classnames from "classnames";

import styles from "./DataTable.scss";
import { NestedTableCell } from "./NestedTableCell";
import { CheckState, TableColumn, TableDataType } from "./types";

interface NestedTableRowProps {
  columns: TableColumn[];
  dataItem: TableDataType;
  defaultAlignment?: string;
  isExpanded?: boolean;
  nestedLevel?: number;
  onToggleSelectOne: () => void;
  showCheckboxes?: boolean;
  onToggleExpansionOne?: (id: any) => void;
  hasChildren: boolean;
  checkState: CheckState;
  dataKey: (item: TableDataType) => number | string;
}

export function NestedTableRow({
  checkState,
  columns,
  dataItem,
  dataKey,
  defaultAlignment,
  hasChildren,
  isExpanded = false,
  nestedLevel = 0,
  onToggleExpansionOne,
  onToggleSelectOne,
  showCheckboxes = false,
}: NestedTableRowProps): React.ReactElement {
  const mainRowClassNames = classnames(styles.row);
  const id = dataKey(dataItem);
  return (
    <tr className={mainRowClassNames}>
      {columns.map(({ header, alignment, renderCell }, index) => {
        const key = `${header}-${id}`;
        return (
          <NestedTableCell
            key={key}
            alignment={alignment || defaultAlignment}
            renderCell={renderCell}
            dataItem={dataItem}
            nestedLevel={index === 0 ? nestedLevel : 0}
            onToggleSelectOne={onToggleSelectOne}
            withCheckbox={showCheckboxes && index === 0}
            isExpanded={isExpanded}
            firstColumn={index === 0}
            onToggleExpansionOne={onToggleExpansionOne}
            hasChildren={hasChildren}
            checkState={checkState}
            dataKey={dataKey}
          />
        );
      })}
    </tr>
  );
}
